import { render } from "./PopUpPreviewExercise.vue?vue&type=template&id=7a43959c"
import script from "./PopUpPreviewExercise.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewExercise.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__